import { connect } from 'react-redux';

import RegistrationStep from '../../../enums/RegistrationStep';

import CustomerStep from './CustomerStep';
import PaymentStep from './PaymentStep';
import SummaryStep from './SummaryStep';
import FormSteps from './FormSteps';

import style from './styles/RegistrationForm.scss';

/**
 * @property {FormStepConfig[]}         props.steps
 * @property {string[]}                 props.checkedSteps
 */
const RegistrationForm = ({ activeStep, checkedSteps, errors }) => {
	let step;

	switch (activeStep) {
		case RegistrationStep.PAYMENT:
			step = (<PaymentStep />);
			break;
		case RegistrationStep.SUMMARY:
			step = (<SummaryStep />);
			break;
		case RegistrationStep.CUSTOMER:
		default:
			step = (<CustomerStep />);
	}

	const errorList = errors && errors.length > 0 ? (
		<ul className="text-danger">
			{errors.map((error, index) => (
				<li key={index}>{error}</li>
			))}
		</ul>
	) : null;

	return (
		<div className={style['registration-form']}>
			<FormSteps {...{ activeStep, checkedSteps }} />
			<div>{errorList}</div>
			{step}
		</div>
	);
};

const mapStateToProps = (state) => {
	const { raffleForm: { activeStep, checkedSteps, errors } } = state;

	return {
		activeStep,
		checkedSteps,
		errors
	};
};

export default connect(mapStateToProps)(RegistrationForm);



// WEBPACK FOOTER //
// ./components/blocks/raffleForm/RegistrationForm.js